import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
export default class LazyImages {
    constructor() {
        this.lazyImages = document.querySelectorAll('img[data-src]');
        if (this.lazyImages.length) {
            this.init();
        }
    }
    init() {
        ScrollTrigger.create({
            trigger: '#main',
            start: 'top+=100 top',
            end: 'bottom -65%',
            once: true,
            //markers: true,
            onEnter: (self) => {
                this.lazyImages.forEach(lazyImage => {
                    lazyImage.src = lazyImage.dataset.src;
                    lazyImage.removeAttribute('data-src');
                });
            },
        });
    }
}
